export default __webpack_public_path__ + "static/media/guesser-bg.42a74723.png";